<template>
  <short-text-filter
    :id="filterData.key + '-filter'"
    :label="filterData.label"
    :update-method="updateValue"
    :use-json-api-filter-manager="false"
  />
</template>

<script>
import ShortTextFilter from "../ShortTextFilter.vue";

export default {
  name: "StringFilter",
  data() {
    return {};
  },
  props: {
    filterData: {
      type: Object,
      required: true,
    },
  },
  components: {
    ShortTextFilter,
  },
  methods: {
    updateValue(value) {
      if (value === "") {
        value = null;
      }
      this.$emit("update-filters", this.filterData.key, value, "CONTAINS");
      this.$emit("update-filter", { id: this.filterData.key, value });
    },
  },
};
</script>
